import CarBreadcrumb from "../../commonComponents/breadcrumbs/CarBreadcrumb";
import CarDetail from "../../commonComponents/productDetail/CarDetail";

const CarExpandSliderContainer = () => {
  return (
    <>
      <CarBreadcrumb type="car_expand_slider" mailClass="style-breadcrumbs-2" />
      <CarDetail type="car" />
    </>
  );
};

export default CarExpandSliderContainer;
